  //=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// custom pages
import config from "config/index";
import HandleApiResponse from "helpers/handleApiResponse";

function startupUnEnrollmentsAPI() {
  const { handleResponse, handleError } = HandleApiResponse();

  
    async function createUnenrollmentReqAPI(values) {
      try {
        const obj = {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(values),
        };
    
        const res = await fetch(
          `${config.host}/cdr-panel/startup-unenrollments/create-unenrollment`,
          obj
        );
    
        // Optional: Safety check before handling
        if (!res.ok) throw new Error(`Request failed with status ${res.status}`);
    
        return handleResponse(res);
      } catch (err) {
        return handleError(err); // Ensure error is passed along
      }
    }

  async function getStartupUnenrollment(values) {
    try {
      const obj = {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/startup-unenrollments/get-startup-unenrollment?query=${query}`,
        obj
      );
      console.log(res,"res")
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }
  async function getPendingUnenrollment(values) {
      try {
        const obj = {
          method: "GET",
          credentials: 'include',
          headers: {
            "Content-Type": "application/json"
          },
        };
        let query = JSON.stringify(values);
        let res = await fetch(
          `${config.host}/cdr-panel/startup-unenrollments/get-pending-unenrollment?query=${query}`,
          obj
        );
        return handleResponse(res);
      }
      catch (err) {
        handleError(err);
      }
    }
    async function searchPendingUnenrollment(values) {
        try {
          const obj = {
            method: "GET",
            credentials: "include",
            headers: {
              "Content-Type": "application/json"
            },
          };
          let query;
          query = JSON.stringify(values);
          let res = await fetch(
            `${config.host}/cdr-panel/startup-unenrollments/searchPending-unenrollment?query=${query}`,
            obj
          );
     
          return handleResponse(res);
        } catch (err) {
          handleError(err);
        }
      }
    
      async function unenrollmentsearchAPI(values) {
        try {
          const obj = {
            method: "GET",
            credentials: "include",
            headers: {
              "Content-Type": "application/json"
            },
          };
          let query;
          query = JSON.stringify(values);
          let res = await fetch(
            `${config.host}/cdr-panel/startup-unenrollments/unenrollment-search?query=${query}`,
            obj
          );
     
          return handleResponse(res);
        } catch (err) {
          handleError(err);
        }
      }
       async function unenrollmentFilter(values) {
          try {
            const obj = {
              method: "GET",
              credentials: 'include',
              headers: {
                "Content-Type": "application/json"
              },
            };
            let query;
            query = JSON.stringify(values);
            let res = await fetch(
              `${config.host}/cdr-panel/startup-unenrollments/unenrollment-filter?query=${query}`,
              obj
            );
            return handleResponse(res);
          } catch (err) {
            handleError(err);
          }
        }
        async function getStartupUnenrollmentReason(values) {
          try {
            const obj = {
              method: "GET",
              credentials: 'include',
              headers: {
                "Content-Type": "application/json"
              },
            };
            
            let res = await fetch(
              `${config.host}/cdr-panel/startup-unenrollments/unenrollment-reason`,
              obj
            );
            return handleResponse(res);
          }
          catch (err) {
            handleError(err);
          }
        }
      
        async function unenrollmentExport(values) {
          try {
            const obj = {
              method: "GET",
              credentials: 'include',
              headers: {
                "Content-Type": "application/json"          
              },
            };
            let query = JSON.stringify(values);
            let res = await fetch(
              `${config.host}/cdr-panel/startup-unenrollments/unenrollment-export?query=${query}`,
              obj
            );
            return handleResponse(res);
          } catch (err) {
            handleError(err);
          }
        }

    
      async function billingClosureApi(values) {
        try {
          const obj = {
            method: "POST",
            credentials: "include",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify(values), // Send `values` in the body
          };
     
          const res = await fetch(
            `${config.host}/cdr-panel/startup-unenrollments/billing-closure-uenrollment`,
            obj
          );
     
          return handleResponse(res);
        } catch (err) {
          handleError(err);
        }
      }
     
      async function addOnPlansRemover(values) {
        try {
          const obj = {
            method: "POST",
            credentials: "include",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify(values), // Send `values` in the body
          };
     
          const res = await fetch(
            `${config.host}/cdr-panel/startup-unenrollments/add-on-plans-remover-unenrollment`,
            obj
          );
     
          return handleResponse(res);
        } catch (err) {
          handleError(err);
        }
      }

      async function getbillingunenrollmentrecord(values) {
          try {
            const obj = {
              method: "GET",
              credentials: 'include',
              headers: {
                "Content-Type": "application/json"
              },
            };
            let query = JSON.stringify(values);
            let res = await fetch(
              `${config.host}/cdr-panel/startup-unenrollments/billing-record-unenrollment?query=${query}`,
              obj
            );
            return handleResponse(res);
          }
          catch (err) {
            handleError(err);
          }
        }
      
        async function billingdateunenrollment(values) {
          try {
            const obj = {
              method: "POST",
              credentials: "include",
              headers: {
                "Content-Type": "application/json"
              },
              body: JSON.stringify(values),
            };
        
            const res = await fetch(
              `${config.host}/cdr-panel/startup-unenrollments/billing-datesetting-unenrollment`,
              obj
            );
        
            // Optional: Safety check before handling
            if (!res.ok) throw new Error(`Request failed with status ${res.status}`);
        
            return handleResponse(res);
          } catch (err) {
            return handleError(err); // Ensure error is passed along
          }
        }
      
         async function billingunenrollmentsearchAPI(values) {
          try {
            const obj = {
              method: "GET",
              credentials: "include",
              headers: {
                "Content-Type": "application/json"
              },
            };
            let query;
            query = JSON.stringify(values);
            let res = await fetch(
              `${config.host}/cdr-panel/startup-unenrollments/billing-record-unenrollment-search?query=${query}`,
              obj
            );
       
            return handleResponse(res);
          } catch (err) {
            handleError(err);
          }
        }

         async function getaddplanunenrollrecord(values) {
            try {
              const obj = {
                method: "GET",
                credentials: 'include',
                headers: {
                  "Content-Type": "application/json"
                },
              };
              let query = JSON.stringify(values);
              let res = await fetch(
                `${config.host}/cdr-panel/startup-unenrollments/addplan-record-unenrollment?query=${query}`,
                obj
              );
              return handleResponse(res);
            }
            catch (err) {
              handleError(err);
            }
          }
        
           async function addplanenrollmentunenrollsearchAPI(values) {
            try {
              const obj = {
                method: "GET",
                credentials: "include",
                headers: {
                  "Content-Type": "application/json"
                },
              };
              let query;
              query = JSON.stringify(values);
              let res = await fetch(
                `${config.host}/cdr-panel/startup-unenrollments/addplan-record-unenrollment-search?query=${query}`,
                obj
              );
         
              return handleResponse(res);
            } catch (err) {
              handleError(err);
            }
          }

          async function cancelenrollmentAPI(values) {
              try {
                const obj = {
                  method: "POST",
                  credentials: "include",
                  headers: {
                    "Content-Type": "application/json"
                  },
                  body: JSON.stringify(values), // Send `values` in the body
                };
            
                const res = await fetch(
                  `${config.host}/cdr-panel/startup-unenrollments/cancel-enrollment`,
                  obj
                );
            
                return handleResponse(res);
              } catch (err) {
                handleError(err);
              }
            }
        
        
         
    
  return {
    getStartupUnenrollment,
    getPendingUnenrollment,
    searchPendingUnenrollment,
    unenrollmentsearchAPI,
    unenrollmentFilter,
    unenrollmentExport,
    getStartupUnenrollmentReason,
    createUnenrollmentReqAPI,
    addOnPlansRemover,
    billingClosureApi,
    getbillingunenrollmentrecord,
    billingdateunenrollment,
    billingunenrollmentsearchAPI,
    getaddplanunenrollrecord,
    addplanenrollmentunenrollsearchAPI,
    cancelenrollmentAPI
  };
}

export default startupUnEnrollmentsAPI;
